import styled from "styled-components";

export const UpsellRocketIconWrap = styled.div<{
  bgColor?: string;
  color?: string;
}>`
  width: 20px;
  height: 20px;
  background-color: ${({ bgColor }) => bgColor || "#4f31ff"};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    color: ${({ color }) => color || "#fff"};
    font-size: 10px !important;
  }
`;

export function UpsellRocketIcon({
  bgColor,
  color,
}: {
  bgColor?: string;
  color?: string;
}) {
  return (
    <UpsellRocketIconWrap bgColor={bgColor} color={color}>
      <i className="fa-regular fa-rocket-launch"></i>
    </UpsellRocketIconWrap>
  );
}
